import { useEffect, useRef, useState } from "react";
import type { ReactElement } from "react";
import { Icon } from "@kundeninfo/ui";
import { KiKnopf } from "../../components/meHuellen.js";

/** ÜBERGANG T-4 — Quittung mit Aktion (me-design hat kein Toast-Element mit Aktion): steht unten
 *  links über dem Inhalt, schließt nach 7 s (F23), „Rückgängig" bucht gegen. Solange der Zeiger
 *  darauf steht oder der Fokus darin ist, bleibt sie stehen; danach laufen die 7 s neu. Kreuz
 *  (Hausregel: Kreuz in jedem Overlay) und Escape schließen sie — Escape nur, wenn der Fokus in
 *  ihr steht: Am Escape-Stapel nähme sie sonst einem offenen Dialog die Taste weg. */
export const QUITTUNG_MS = 7_000;

export function TicketQuittung(p: { text: string; onRueckgaengig: () => void; onSchliessen: () => void }): ReactElement {
  const schliessen = useRef(p.onSchliessen);
  schliessen.current = p.onSchliessen;
  const [zeiger, setZeiger] = useState(false);
  const [fokus, setFokus] = useState(false);
  const haelt = zeiger || fokus;
  useEffect(() => {
    if (haelt) return undefined;
    const t = setTimeout(() => schliessen.current(), QUITTUNG_MS);
    return () => clearTimeout(t);
  }, [p.text, haelt]);
  return (
    <div className="tq" role="status" aria-live="polite"
      onMouseEnter={() => setZeiger(true)} onMouseLeave={() => setZeiger(false)}
      onFocus={() => setFokus(true)}
      onBlur={(e) => { if (!e.currentTarget.contains(e.relatedTarget as Node | null)) setFokus(false); }}
      onKeyDown={(e) => { if (e.key === "Escape") { e.stopPropagation(); p.onSchliessen(); } }}>
      <span className="tq__text">{p.text}</span>
      <KiKnopf art="leise" onClick={p.onRueckgaengig}>Rückgängig</KiKnopf>
      <KiKnopf art="leise" name="Quittung schließen" onClick={p.onSchliessen}>
        <Icon name="xmark" size={14} />
      </KiKnopf>
    </div>
  );
}
